import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_PRICE_LIST_ITEM_COLLECTION_NAME = "price-list-item";

export const useRxCollectionPriceListItem =
  (): RxCollection<PriceListItem> | null =>
    useRxCollection<PriceListItem>(RXDB_PRICE_LIST_ITEM_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<PriceListItem>>;
export type PriceListItemQueryConstructor = UseRxData["1"];

const PRICE_LIST_ITEM_SCHEMA_LITERAL = {
  title: "price list item schema",
  version: 1,
  description: "An item that prices reference (reachability-scoped)",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    active: {
      type: "boolean",
    },
    meta: SYNCABLE_META,
  },
  required: ["id", "active", "meta"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(PRICE_LIST_ITEM_SCHEMA_LITERAL);

export type PriceListItem = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const PRICE_LIST_ITEM_SCHEMA: RxJsonSchema<PriceListItem> =
  PRICE_LIST_ITEM_SCHEMA_LITERAL;
